import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Identity } from '../../../models/client';
import { AppLoginMeta, AppPlatform, LoginMeta, PasswordLoginDto, RefreshTokenDto, TokenDto } from '../../../models/server/DataTransferObject/Objects/Authentication';
import { LoginByBadgeDto, LoginByPinDto } from '../../../models/server/DataTransferObject/Objects/Permissions';
import { RegisterDeviceDto } from '../../../models/server/Nexnox/Core/Shared/DataTransferObject/Objects/Devices/RegisterDeviceDto';
import { DeviceService } from '../../ui/device/device.service';
import { PlatformService } from '../../ui/device/platform.service';
import { HttpLoginApiService } from '../http/http-login-api/http-login-api.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {  

  constructor(
    private http: HttpLoginApiService
  ) { }



  public async loginWithPassword(user: string, password: string) : Promise<HttpResponse<TokenDto>> {
    const body = <PasswordLoginDto> {
      email: user,
      passwordBase64: btoa(password)
    };

    return this.http.post<TokenDto>('login/password', body).toPromise();
  }

  public async loginWithDevicePin(dto: RegisterDeviceDto) : Promise<HttpResponse<TokenDto>> {
    const path = `login/RegisterDeviceByCode`;
    return this.http.post<TokenDto>(path, dto).toPromise();
  }

  public async loginWithUserPin(identity: Identity, dto: LoginByPinDto) : Promise<HttpResponse<TokenDto>> {
    const path = `login/pin`;
    const headers = new HttpHeaders().set('Authorization', `Bearer ${identity.token}`);

    return this.http.post<TokenDto>(path, dto, headers).toPromise();
  }
  public async loginWithUserBadge(identity: Identity, dto: LoginByBadgeDto) : Promise<HttpResponse<TokenDto>> {
    const path = `login/badge`;
    const headers = new HttpHeaders().set('Authorization', `Bearer ${identity.token}`);

    return this.http.post<TokenDto>(path, dto, headers).toPromise();
  }
  
  public async loginRefresh(refreshToken: string, tenantId?: number) : Promise<HttpResponse<TokenDto>> {
    const body  = <RefreshTokenDto> <unknown>{
      refreshToken: refreshToken,
      tenantId: tenantId,
      client: 2
    };
    
    return this.http.post<TokenDto>('v3/login/refresh', body).toPromise();
  }
}
